import { createFileRoute } from '@tanstack/react-router';

import { GridViewerPage } from '@/pages/grid-viewer/grid-viewer-page';

export const Route = createFileRoute('/grid-editor/$diagramId_/view')({
    component: GridViewerRoute,
    // The page-level header tray owns both corners on desktop: app nav
    // in the left end, account avatar in the right.
    staticData: { ownTopLeft: true, ownTopRight: true },
});

function GridViewerRoute() {
    const { diagramId } = Route.useParams();
    return <GridViewerPage diagramId={diagramId} />;
}
